<script>
export default {
  name: 'BrandColors',
  data () {
    return {
        brandCss: `
          .gg-branding-lead {
            color: ${this.$store.state.dog.lead_color};
          }
          .gg-branding-supporting {
            color: ${this.$store.state.dog.supporting_color};
          }
          .gg-branding-backdrop {
            color: ${this.$store.state.dog.backdrop_color};
          }
          .gg-branding-lead-bg {
            background-color: ${this.$store.state.dog.lead_color};
          }
          .gg-branding-supporting-bg {
            background-color: ${this.$store.state.dog.supporting_color};
          }
          .gg-branding-backdrop-bg {
            background-color: ${this.$store.state.dog.backdrop_color};
          }
          a.gg-branding-lead:hover {
            color: ${this.$store.state.dog.lead_color};
            opacity: .8;
          }
          `
    }
  },
  render: function (createElement) {
    return createElement('style', {}, this.brandCss)
  },
}
</script>
